import { render, staticRenderFns } from "./DefaultForgotPassword.vue?vue&type=template&id=f21dc798&"
import script from "./DefaultForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./DefaultForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports